export default __webpack_public_path__ + "alberta-notification.c07bb549fec60159338b.svg";